import { flexRender, type Row } from '@tanstack/react-table';

import { cn } from '@nesso/ui/lib/utils';
import { TableCell, TableRow } from '@nesso/ui/primitives/table';

import {
    NAME_COLUMN_SCROLL_SHADOW,
    type PracticeMemberUsageRow,
} from './reporting-page-practice-member-usage-table-columns';

// Body cells are 52px regardless of content, unlike TableCell's default content-sized height.
const ROW_HEIGHT = 'h-13';

type Props = {
    row: Row<PracticeMemberUsageRow>;
    isScrolled: boolean;
};

export function ReportingPagePracticeMemberUsageTableRow({ row, isScrolled }: Props) {
    return (
        <TableRow
            className={cn(
                'bg-background hover:bg-[color-mix(in_oklab,var(--muted)_50%,var(--background))]',
                ROW_HEIGHT,
            )}
        >
            {row.getVisibleCells().map((cell) => (
                // Width comes from `meta.className`. Scroll shadow comes from `isScrolled` instead
                // — a virtualized row's cached `columnDef` doesn't pick up the rebuilt meta class.
                <TableCell
                    key={cell.id}
                    className={cn(
                        cell.column.columnDef.meta?.className,
                        cell.column.id === 'name' && isScrolled && NAME_COLUMN_SCROLL_SHADOW,
                    )}
                >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
            ))}
        </TableRow>
    );
}
